import { apiGet, apiPost } from "./Api/apiCall";

export type ManualCommandParameterDefinition =
  | {
      name: string;
      label: string;
      type: "select";
      required?: boolean;
      defaultValue: string;
      options: Array<{
        label: string;
        value: string;
      }>;
    }
  | {
      name: string;
      label: string;
      type: "string";
      required?: boolean;
      defaultValue?: string;
    }
  | {
      name: string;
      label: string;
      type: "number";
      required?: boolean;
      defaultValue?: number;
    };

export interface ManualCommandDefinition {
  key: string;
  label: string;
  description: string;
  commandName: string;
  project: "backoffice" | "legalbird";
  parameters?: ManualCommandParameterDefinition[];
}

export interface ManualCommandRun {
  id: number;
  commandKey: string;
  commandName: string;
  commandParameters: Record<string, string | number>;
  status: "queued" | "running" | "completed" | "failed";
  kubernetesNamespace: string | null;
  kubernetesJobName: string | null;
  kubernetesPodName: string | null;
  exitCode: number | null;
  output: string | null;
  errorMessage: string | null;
  requestedByBackofficeUserId: number | null;
  startedAt: string | null;
  finishedAt: string | null;
  created: string | null;
  updated: string | null;
}

export async function startManualCommand(
  commandKey: string,
  parameters: Record<string, string | number> = {},
): Promise<ManualCommandRun> {
  return apiPost<ManualCommandRun>("/manual_command_runs", { commandKey, parameters });
}

export async function getManualCommandRuns(): Promise<ManualCommandRun[]> {
  return apiGet<ManualCommandRun[]>("/manual_command_runs");
}
